module.exports = __webpack_public_path__ + "img/payattitude-light.369aea38.svg";